var map = {
	"./about-us-banner.webp": 218,
	"./anniversary-banner-bm.webp": 1586,
	"./anniversary-banner-cn.webp": 1587,
	"./anniversary-banner-id.webp": 1588,
	"./anniversary-banner.webp": 1589,
	"./banner-01.jpg": 1590,
	"./banner-slot.jpg": 1591,
	"./bet-and-earn-banner-cn.webp": 1592,
	"./bet-and-earn-banner-indon.webp": 1593,
	"./bet-and-earn-banner-ms.webp": 1594,
	"./bet-and-earn-banner.webp": 1595,
	"./check-in-banner-cn.webp": 1596,
	"./check-in-banner-id.webp": 1597,
	"./check-in-banner-ms.webp": 1598,
	"./check-in-banner.webp": 1599,
	"./cny_2024-bm.webp": 1600,
	"./cny_2024-cn.webp": 1601,
	"./cny_2024.webp": 1602,
	"./epl-banner-cn.jpg": 1603,
	"./epl-banner-cn.webp": 1604,
	"./epl-banner-indo.jpg": 1605,
	"./epl-banner-indo.webp": 1606,
	"./epl-banner-ms.jpg": 1607,
	"./epl-banner-ms.webp": 1608,
	"./epl-banner.jpg": 1609,
	"./epl-banner.webp": 1610,
	"./games-banner-cn.webp": 1611,
	"./games-banner-id.webp": 1612,
	"./games-banner-ms.webp": 1613,
	"./games-banner.webp": 1614,
	"./lb-m-banner-cn.webp": 1615,
	"./lb-m-banner.webp": 1616,
	"./leaderboard-banner-cn.webp": 1617,
	"./leaderboard-banner.webp": 1618,
	"./lottery-banner.webp": 1619,
	"./lottery-banners-cn.webp": 1620,
	"./lottery-banners-id.webp": 1621,
	"./lottery-banners-ms.webp": 1622,
	"./lottery-banners.webp": 1623,
	"./lucky-spin-banner-cn.webp": 1624,
	"./lucky-spin-banner-ms.webp": 1625,
	"./lucky-spin-banner-vn.webp": 1626,
	"./lucky-spin-banner.webp": 1627,
	"./p2p-banner.webp": 1628,
	"./p2p-banners-cn.webp": 1629,
	"./p2p-banners-id.webp": 1630,
	"./p2p-banners-ms.webp": 1631,
	"./p2p-banners.webp": 1632,
	"./premier-league-banner-cn.webp": 1633,
	"./premier-league-banner.webp": 1634,
	"./promos-banner-cn.webp": 1635,
	"./promos-banner-indon.webp": 1636,
	"./promos-banner-ms.webp": 1637,
	"./promos-banner.webp": 1638,
	"./promos-detail-banner.jpg": 1639,
	"./side-bar-banner.jpg": 1640,
	"./slot-banners-cn.webp": 1641,
	"./slot-banners-ms.webp": 1642,
	"./slot-banners.webp": 1643,
	"./speed-banners-cn.webp": 1644,
	"./speed-banners-ms.webp": 1645,
	"./speed-banners.webp": 1646,
	"./uefa24-prediction-bm.webp": 1647,
	"./uefa24-prediction-cn.webp": 1648,
	"./uefa24-prediction-id.webp": 1649,
	"./uefa24-prediction.webp": 1650,
	"./vip-banner-cn.webp": 1651,
	"./vip-banner-id.webp": 1652,
	"./vip-banner-ms.webp": 1653,
	"./vip-banner-vn.webp": 1654,
	"./vip-banner.webp": 1655,
	"./winner-leaderboard-banner-cn.webp": 1656,
	"./winner-leaderboard-banner.webp": 1657,
	"./world-cup-banner-cn.webp": 1658,
	"./world-cup-banner.webp": 1659,
	"./world-cup-two-banner-cn.webp": 1660,
	"./world-cup-two-banner.webp": 1661,
	"./xmas_2023-bm.jpg": 1662,
	"./xmas_2023-cn.jpg": 1663,
	"./xmas_2023-id.jpg": 1664,
	"./xmas_2023.jpg": 1665,
	"./xmas_2024-bm.webp": 1666,
	"./xmas_2024-cn.webp": 1667,
	"./xmas_2024.webp": 1668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;